import React from 'react'
// containers
import Integrations from 'components/PageComponents/Settings/Integrations'

const IntegrationsPage: React.FC = () => <Integrations />

export default IntegrationsPage
